// pages/EarningsDashboard.jsx
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import BasicCustomTable from "../../component/basicTable";
import { earningColumns, earningData } from "../../constants/delivery";
import DateFilter from "../../component/dateFilter";
import { useSelector } from "react-redux";
import axiosInstance from "../../configuration/request";
import { useSnackbar } from "../../component/SnackbarContext";
import DashboardCards from "../../component/DashboardCards";
import { BsCurrencyDollar } from "react-icons/bs";
import { FaRegCalendarAlt } from "react-icons/fa";
import { MdOutlineAttachMoney } from "react-icons/md";

const summaryCards = [
  { name: "Weekly Earnings", value: "$0" ,icon: FaRegCalendarAlt},
  { name: "Monthly Earnings", value: "$0",icon: MdOutlineAttachMoney },
];

function EarningsDashboard() {
  const deliveryId = useSelector((state) => state.counter.deliveryPersonId);
  const showSnackbar = useSnackbar();
  const [summaryData, setSummaryData] = useState(summaryCards);
  const [jobsData, setJobsData] = useState([]);

  const handleRangeSelect = (range) => {
    console.log("Selected Date Range:", range);
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

 const fetchDashboardData = () => {
  axiosInstance
    .get(`/customer/delivery-person/earnings/${deliveryId}`)
    .then((res) => {
      const data = res?.data;

      if (data) {
        setSummaryData([
          {
            name: "Monthly Earnings",
            value: `$${data.monthlyEarnings ?? 0}`,
            icon: MdOutlineAttachMoney,   
          },
          {
            name: "Weekly Earnings",
            value: `$${data.weeklyEarnings ?? 0}`,
            icon: FaRegCalendarAlt,
          },
        ]);

        const transformedJobs = (data.jobs ?? []).map((job) => ({
          job_id: job.jobId,
          date: dayjs(job.date).format("DD MMM YYYY"),
          amount: `$${job.amount ?? 0}`,
          status_tag: job.status ?? "-",
          type: job.type ?? "-",
        }));

        setJobsData(transformedJobs);
      }
    })
    .catch((error) => {
      showSnackbar(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
    });
};

  return (
    <div className="pt-1 pb-4 pr-6 pl-6 w-full space-y-6">
      <div className="flex justify-between">
        <h1 className="text-2xl font-semibold text-[var(--primary-text-color)]">
          Earnings Dashboard
        </h1>
        <DateFilter onSelectRange={handleRangeSelect} />
      </div>

      <div className="flex justify-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl w-full">
          {summaryData.map((card, idx) => (
            <DashboardCards
              key={idx}
              index={idx}
              title={card.name}
              value={card.value}
              icon={card.icon}
            />
          ))}
        </div>
      </div>

      <BasicCustomTable
        columns={earningColumns}
        rows={jobsData}
        colorHeader={true}
        customClassHeader="table-header-cell-colored"
        maxHeightClass="max-h-[calc(100vh-230px)]"
        frontendPagination={true}
         pageLimit={10}
      />

      <p className="text-xs text-gray-500">
        * Showing historical earnings from the last 1 year only.
      </p>
    </div>
  );
}

export default EarningsDashboard;
